"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

var _propTypes = _interopRequireDefault(require("prop-types"));

// NOTE: Please keep in sync with theme.js
var xSmall = 375;
var small = 475;
var medium = 768;
var portfolioMedium = 992;
var large = 1024;
var portfolioLarge = 1088;
var xLarge = 1280;
var desktop = 1440; // Children of Responsive are only shown within defined window widths.
// Responsive component is intended to be wrapped by a HOC to pre-define responsive sizes.

var Responsive = function Responsive(_ref) {
  var exact = _ref.exact,
      orSmaller = _ref.orSmaller,
      orLarger = _ref.orLarger,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      children = _ref.children;
  var props = {};
  var both = exact || !orSmaller && !orLarger;
  var useMax = (orSmaller || both) && maxWidth;
  var useMin = (orLarger || both) && minWidth;

  if (useMax) {
    props.maxWidth = maxWidth;
  }

  if (useMin) {
    props.minWidth = minWidth;
  }

  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], props, children);
};

Responsive.defaultProps = {
  exact: false,
  orSmaller: false,
  orLarger: false,
  children: null,
  minWidth: null,
  maxWidth: null
};
Responsive.propTypes = {
  exact: _propTypes["default"].bool,
  orSmaller: _propTypes["default"].bool,
  orLarger: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  minWidth: _propTypes["default"].number,
  maxWidth: _propTypes["default"].number
};
Responsive.widths = {
  small: small,
  medium: medium,
  large: large,
  desktop: desktop
};

Responsive.Desktop = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: desktop
  }));
};

Responsive.Desktop.displayName = 'Responsive.Desktop';

Responsive.XLarge = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: xLarge,
    maxWidth: desktop - 1
  }));
};

Responsive.XLarge.displayName = 'Responsive.XLarge';

Responsive.Large = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: large,
    maxWidth: xLarge - 1
  }));
};

Responsive.Large.displayName = 'Responsive.Large';

Responsive.Medium = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: medium,
    maxWidth: large - 1
  }));
};

Responsive.Medium.displayName = 'Responsive.Medium';

Responsive.Small = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: small,
    maxWidth: medium - 1
  }));
};

Responsive.Small.displayName = 'Responsive.Small';

Responsive.xSmall = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: xSmall,
    maxWidth: small - 1
  }));
};

Responsive.xSmall.displayName = 'Responsive.xSmall';

Responsive.Mobile = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    maxWidth: xSmall - 1
  }));
};

Responsive.Mobile.displayName = 'Responsive.Mobile';

Responsive.PortfolioLarge = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: portfolioLarge
  }));
}; // eslint-disable-next-line max-len


Responsive.PortfolioMedium = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: portfolioMedium,
    maxWidth: portfolioLarge - 1
  }));
}; // eslint-disable-next-line max-len


Responsive.PortfolioRegularMedium = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: medium,
    maxWidth: portfolioMedium - 1
  }));
}; // Non-mobile (at least small)


Responsive.Default = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Responsive, (0, _extends2["default"])({}, props, {
    minWidth: small
  }));
};

var _default = Responsive;
exports["default"] = _default;